import { List, ListItem, ListItemText } from "@mui/material";
import { DisclosureHost } from "../../hooks/use-disclosure";
import { setCallData } from "../../redux/feature/join-room/JoinRoomSlice";
import { store } from "../../redux/store";
import Text from "../Text";
import ConfirmationModal from "../app/ConfirmationModal";
import { formatDateTime } from "../../utils/date-time-utility";
import { replaceUnderScoreAddSpace } from "../../utils/utils";

interface ReminderModalProps {
  disclosureHost: DisclosureHost;
  appointment: any;
}

const ReminderModal = ({ disclosureHost, appointment }: ReminderModalProps) => {
  const handleNavigateToPreview = () => {
    const patientIdParam = appointment?.patientId
      ? `&patientid=${appointment?.patientId}`
      : "";
    const appointmentIdParam = appointment?.uuid
      ? `&appointmentid=${appointment?.uuid}`
      : "";

    store.dispatch(
      setCallData({
        patientId: appointment?.patientId,
        appointmentId: appointment?.uuid,
        patientName: appointment?.patientName ?? "",
        providerName: appointment?.providerName ?? "",
        startTime: appointment?.startTime,
        role: 1,
      })
    );
    NavigationHelper.navigate(
      `/app/preview?room=${appointment?.room}&role=${1}&providerName=${
        appointment?.providerName ?? ""
      }&patientName=${appointment?.patientName ?? ""}&startTime=${
        appointment?.startTime
      }${patientIdParam}${appointmentIdParam}`
    );
    disclosureHost.close();
  };

  const REMINDER_DATA = [
    { label: "Patient Name", k: "patientName" },
    { label: "Chief Complaint", k: "chiefComplaint" },
    { label: "Appointment Type", k: "type" },
    { label: "Appointment Mode", k: "mode" },
    { label: "Scheduled Date & Time", k: "startTime" },
  ];

  return (
    <ConfirmationModal
      maxWidth={"sm"}
      disclosureHost={disclosureHost}
      cancelText="Cancel"
      onConfirm={handleNavigateToPreview}
      confirmationText="Join"
      title={
        <>
          <Text fontWeight={"medium"} fontSize={"24px"}>
            Your Upcoming Appointment is Scheduled
          </Text>
          <List
            component="ul"
            dense
            disablePadding
            sx={{
              listStyleType: "disc",
              listStylePosition: "outside",
              pl: 2.5,
            }}
          >
            {REMINDER_DATA.map((app) => {
              let displayValue: string | undefined;

              if (app.k === "startTime") {
                displayValue = formatDateTime(appointment?.[app.k]);
              } else if (app.k === "mode") {
                displayValue = replaceUnderScoreAddSpace(
                  appointment?.[app.k] ?? ""
                );
              } else {
                displayValue = appointment?.[app.k];
              }

              return (
                <ListItem
                  key={app.k}
                  component="li"
                  disablePadding
                  sx={{ display: "list-item" }}
                >
                  <ListItemText
                    primary={`${app.label}: ${displayValue ?? "-"}`}
                    slotProps={{
                      primary: { variant: "body2" },
                    }}
                  />
                </ListItem>
              );
            })}
          </List>
        </>
      }
    />
  );
};

export default ReminderModal;

/**
 * ``To use Navigator outside the Provider``
 *
 * @returns NavigatorContainer
 */
class NavigationHelper {
  static navigate(path: string) {
    window.history.pushState({}, "", path);
    window.dispatchEvent(new PopStateEvent("popstate"));
  }
}
